export default {
  BASE: `https://api.cliprate.com`,
  API: function() {
    return `${this.BASE}/v1`;
  }
};
  
